(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cms-faq"]) return;
  try {
    
  // Open & close FAQ blocks
  $('.faq-block-question').click(function(){
    $(this).parent().toggleClass("bloc_closed bloc_open");
    $(this).next().slideToggle(300);
  });

  } catch(e) { console.error(e); }
})();
})();
